import { createSlice } from '@reduxjs/toolkit';
import { fetchSocialLinks } from '../actions/socialLinksActions';

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

const socialLinksSlice = createSlice({
  name: 'socialLinks',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSocialLinks.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSocialLinks.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data || [];
        state.error = null;
      })
      .addCase(fetchSocialLinks.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'حدث خطأ أثناء جلب روابط السوشيال';
      });
  },
});

export default socialLinksSlice.reducer;
